import PropTypes from 'prop-types';
import HoverMessage from 'common/components/HoverMessage';
import { reactToastify, TOASTIFY_TYPES } from 'common/utils/reactToastify';
import { localCopyToClipboard } from './helper';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const propTypes = {
  isPublicRun: PropTypes.bool.isRequired,
  isBelongsToCurrentUser: PropTypes.bool.isRequired,
  onPublicRunChange: PropTypes.func.isRequired,
  isHiddenSignal: PropTypes.bool.isRequired,
};
const defaultProps = {};

const SocialShare = ({ isPublicRun, onPublicRunChange, isBelongsToCurrentUser, isHiddenSignal }) => {
  // eslint-disable-next-line no-undef
  const encodedUrl = encodeURI(window.location.href);

  const handleCopyLink = () => {
    // eslint-disable-next-line no-undef
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(encodedUrl)
        .then(() => {
          reactToastify('Link copied!', TOASTIFY_TYPES.SUCCESS);
        })
        .catch((err) => {
          console.error('Failed to copy: ', err);
          reactToastify('Failed to copy link', TOASTIFY_TYPES.ERROR);
        });
    } else {
      localCopyToClipboard(encodedUrl);
    }
  };

  const renderPublicPrivateSwitchBtn = () => (
    <label>
      <input type="checkbox" checked={isPublicRun} onChange={onPublicRunChange} />
      <span className="private">Private</span>
      <span className="lever mx-1" />
      <span className="public">Public</span>
    </label>
  );

  const renderSocialShareBtns = () => (
    <div className="align-items-center gap-5 d-flex justify-content-between">
      {isBelongsToCurrentUser && !isHiddenSignal && (
        <div className="share-options switch-btn gap-5">{renderPublicPrivateSwitchBtn()}</div>
      )}
      <div
        key="copy-btn"
        className={`copy-btn btn btn-outline-primary btn-sm ${!isPublicRun ? 'disabled' : ''}`}
        aria-disabled={!isPublicRun}
        onClick={() => isPublicRun && handleCopyLink()}
      >
        <i className="material-icons-outlined tx-16">copy</i>
      </div>
    </div>
  );

  if (!ApplicationDomainUtility.isAlgoverse && isPublicRun) return renderSocialShareBtns();

  return (
    <HoverMessage
      title="Enable Share"
      message={
        !isHiddenSignal
          ? 'To Share and allow others to view your run, switch to Public'
          : 'This run has disabled To Share by the Author'
      }
    >
      {!ApplicationDomainUtility.isAlgoverse ? renderSocialShareBtns() : <></>}
    </HoverMessage>
  );
};

export default SocialShare;

SocialShare.defaultProps = defaultProps;
SocialShare.propTypes = propTypes;
